import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Box, Card, CardContent, Typography, CardHeader, useTheme } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { green, red } from "@mui/material/colors";
import useDailyUser from "../../../hooks/useDailyUser";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDate, addDays } from "../../../utils/common";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const barTopLabels = {
  id: "barTopLabels",
  afterDraw(chart) {
    const { ctx, data } = chart;
    if (!data || !data.datasets) return;
    ctx.save();
    const isDark = chart.canvas.getAttribute("data-theme-mode") === "dark";
    data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      if (!meta || !meta.data) return;
      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        if (value !== undefined && value !== null && value !== 0) {
          const x = bar.x;
          const y = bar.y;

          // Count
          ctx.fillStyle = isDark ? "rgba(255, 255, 255, 0.95)" : "#1e293b";
          ctx.font = "bold 10px 'Inter', sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.fillText(value, x, y - 5);
        }
      });
    });
    ctx.restore();
  },
};

// Register the components with ChartJS
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarCharts = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { getAllDashboardUser, dashboardUsers } = useDailyUser();

  console.log(dashboardUsers, "dataaaaaadddddddddddd");

  const [dashbordData, setDashBoardData] = useState({
    labels: [0, 0, 0, 0, 0, 0, 0],
    datasets: [
      {
        label: "Active",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgb(71, 130, 218)",
        borderColor: "rgb(71, 130, 218)",
        borderWidth: 1,
      },
      {
        label: "Online",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgb(46, 125, 50)",
        borderColor: "rgb(46, 125, 50)",
        borderWidth: 1,
      },
      {
        label: "New",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 0.6)",
        borderWidth: 1,
      },
      {
        label: "Expired",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgb(237, 108, 2)",
        borderColor: "rgb(237, 108, 2)",
        borderWidth: 1,
      },
    ],
  });

  const { state } = useLocation();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllDashboardUser(payload);
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  useEffect(() => {
    console.log(dashboardUsers, "dashboardUsersdashboardUsers");

    if (dashboardUsers && dashboardUsers.length > 0) {
      const labels = dashboardUsers.map((item) => item.date);
      const activeData = dashboardUsers.map((item) => item.activeUserCount);
      const onlineData = dashboardUsers.map((item) => item.onlineUserCount);
      const newData = dashboardUsers.map((item) => item.newUserCount);
      const expireData = dashboardUsers.map((item) => item.expireUserCount);

      const dataSets = [
        {
          label: "Active",
          data: activeData,
          backgroundColor: "rgb(71, 130, 218)",
          borderColor: "rgb(71, 130, 218)",
          borderWidth: 1,
        },
        {
          label: "Online",
          data: onlineData,
          backgroundColor: "rgb(46, 125, 50)",
          borderColor: "rgb(46, 125, 50)",
          borderWidth: 1,
        },
        {
          label: "New",
          data: newData,
          backgroundColor: "rgb(234, 179, 8)",
          borderColor: "rgb(234, 179, 8)",
          borderWidth: 1,
        },
        {
          label: "Expired",
          data: expireData,
          backgroundColor: "rgb(237, 108, 2)",
          borderColor: "rgb(237, 108, 2)",
          borderWidth: 1,
        },
      ];
      setDashBoardData({
        labels: labels,
        datasets: dataSets,
      });
    }
  }, [dashboardUsers]);

  // Options for the chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
            weight: "bold",
          },
          color: isDarkMode ? "rgba(255, 255, 255, 0.9)" : "#333",
        },
      },
      title: {
        display: true,
        font: {
          size: 18,
        },
        color: isDarkMode ? "rgba(255, 255, 255, 0.9)" : "#333",
      },
      tooltip: {
        callbacks: {
          title: (context) => {
            return context[0].raw;
          },
          label: (context) => {
            return context.dataset.label;
          },
        },
        displayColors: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grace: "20%",
        ticks: {
          color: isDarkMode ? "rgba(255, 255, 255, 0.7)" : "#555",
        },
        grid: {
          color: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)",
        },
      },
      x: {
        ticks: {
          color: isDarkMode ? "rgba(255, 255, 255, 0.7)" : "#555",
        },
        grid: {
          color: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)",
        },
      },
    },
  };

  return (
    <Card>
      <CardContent>
        <CardHeader title="User Status" />

        <Box sx={{ height: 250 }}>
          <Bar
            data={dashbordData}
            options={options}
            plugins={[barTopLabels]}
            datasetIdKey="dash-bar"
            ref={(ref) => {
              if (ref?.canvas) {
                ref.canvas.setAttribute("data-theme-mode", theme.palette.mode);
              }
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default BarCharts;
